<div class="popup">
    <div class="popup-header">
        <img src="./assets/images/undraw_add.svg" width="199" height="144" alt="Switching Workspace">
    </div>
    <div class="popup-content">
        <h2>Switching Workspace!</h2>
        <p>Any Progress would be lost in other tabs if  workspace is switched.</p>
    </div>
    <div class="popup-footer">
        <button mat-stroked-button mat-dialog-close >Cancel</button>
        <button mat-raised-button color="primary" (click)="switchWorkspace()">Switch</button>
    </div>
</div>
